import { render } from "./list.vue?vue&type=template&id=22cc7b03&scoped=true&ts=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"

import "./list.vue?vue&type=style&index=0&id=22cc7b03&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cc7b03"],['__file',"src/app/catalog/mapping-template/export-template/list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22cc7b03"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22cc7b03', __exports__)) {
    api.reload('22cc7b03', __exports__)
  }
  
  module.hot.accept("./list.vue?vue&type=template&id=22cc7b03&scoped=true&ts=true", () => {
    api.rerender('22cc7b03', render)
  })

}


export default __exports__